import { render, staticRenderFns } from "./coursesIboughtInfo.vue?vue&type=template&id=ab96d8a8"
import script from "./coursesIboughtInfo.vue?vue&type=script&lang=js"
export * from "./coursesIboughtInfo.vue?vue&type=script&lang=js"
import style0 from "./coursesIboughtInfo.vue?vue&type=style&index=0&id=ab96d8a8&prod&lang=less"
import style1 from "./coursesIboughtInfo.vue?vue&type=style&index=1&id=ab96d8a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports